import React from 'react';
import { humanize, titleize, unescapeHTML } from 'underscore.string';
import classnames from 'classnames';
import { Glyphicon } from 'react-bootstrap';
import { referenceNumberFormatter } from 'components/ui/formatters';
import { useTranslation } from 'react-i18next';
const Location = (props) => {
    const glyph = props.type === 'pickup' ? 'arrow-up' : 'arrow-down';
    const glyphClassName = classnames({
        'text-green': props.type === 'pickup',
        'text-red-500': props.type !== 'pickup',
        'pr-1': true,
    });
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement(Glyphicon, { glyph: glyph, className: glyphClassName }),
            React.createElement("span", { className: "font-bold text-grey-darker" }, titleize(props.location[0].name))),
        React.createElement("div", null,
            React.createElement("span", null, props.location[0].address))));
};
const ShipmentCard = (props) => {
    const s = props.shipment;
    const { t } = useTranslation();
    const wrapperClasses = classnames({
        'border-green-light': props.active,
        border: props.active,
        'border-solid': props.active,
        'border-transparent': !props.active,
    });
    return (React.createElement("div", { className: `text-sm rounded-lg shadow p-2 bg-white cursor-pointer ${wrapperClasses}` },
        React.createElement("div", { onClick: () => props.onClick(s) },
            React.createElement("div", { className: "flex border-solid border-bottom text-grey-darker" },
                React.createElement("div", { className: "w-1/2" },
                    React.createElement("a", { className: "pt-1" }, s.shipment_id)),
                React.createElement("div", { className: "flex justify-end w-1/2" },
                    React.createElement("span", { className: "p-1 text-white rounded bg-green-light" }, titleize(humanize(s.status))))),
            React.createElement("div", null,
                React.createElement("div", { className: "mt-1" },
                    React.createElement("span", { className: "font-semibold text-blue-dark" }, titleize(humanize(unescapeHTML(s.shipper_name))))),
                React.createElement("div", { className: "mt-1" },
                    React.createElement(Location, { location: s.origin, type: "pickup" })),
                React.createElement("div", { className: "mt-1" },
                    React.createElement(Location, { location: s.destination, type: "deliver" })),
                React.createElement("div", { className: "mt-1" }, referenceNumberFormatter(s.reference_numbers)))),
        React.createElement("div", { className: "flex justify-end pt-2 border-t border-solid border-grey" },
            React.createElement("a", { target: "_blank", href: `/shipments/${s._id}`, rel: "noreferrer" }, t('OPEN_IN_NEW_TAB')))));
};
export default ShipmentCard;
